exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer-nav__social {\n  list-style: none;\n  display: inline-block;\n  margin-left: 0;\n  margin-top: 75px;\n  margin-right: 50px;\n  font-size: 1.8rem; }\n\n.footer-nav__social li {\n  margin-right: 10px;\n  padding-left: 0;\n  display: inline-block; }\n\n.footer-nav__social li a {\n  color: #666; }\n\n.footer-nav__social li a:hover,\n.footer-nav__social li a:focus {\n  color: white; }\n\n.footer-nav__social li:last-child {\n  margin: 0; }\n\n.footer-descriptions {\n  padding-top: 5px !important;\n  text-align: center;\n  background-color: #292c34;\n  height: 40px;\n  bottom: 0;\n  position: fixed; }\n\n.info-footer-description {\n  color: #94917e;\n  font-size: 13px; }\n\n.info-footer-description > a {\n  color: #94917e !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/shared/footer/footer.component.scss
// module id = ../../../../../src/app/shared/footer/footer.component.scss
// module chunks = main